import gql from 'graphql-tag';

export const FACEBOOK_SIGN_IN_MUTATION = gql`
    mutation socialSignInFacebook($accessToken: String!) {
        socialSignInFacebook(accessToken: $accessToken) {
            success
        }
    }
`;
